import React from 'react'
import { Div, Flex, LoadingSpinner } from '@sendoutcards/quantum-design-ui'
import { WidgetCard } from 'src/dashboard/components/Widgets/WidgetCard'
import {
  WidgetHeader,
  WidgetHeaderProps,
} from 'src/dashboard/components/Widgets/WidgetHeader'
import {
  EmptyWidget,
  EmptyWidgetProps,
} from 'src/dashboard/components/Widgets/EmptyWidget'

type WidgetProps = {
  header?: WidgetHeaderProps
  emptyState: EmptyWidgetProps
  isEmpty: boolean
  isLoading?: boolean
  borderRadiusOverride?: string
  paddingOverride?: string
  shouldHideShadow?: boolean
  boxShadowOverride?: string
  backgroundColor?: string
  alignment?: 'stretch' | 'start' | 'center'
  minWidth?: string
  height?: string
}

export const Widget: React.FC<WidgetProps> = ({
  header,
  emptyState,
  isEmpty,
  isLoading,
  paddingOverride,
  borderRadiusOverride,
  shouldHideShadow,
  boxShadowOverride,
  backgroundColor,
  children,
  alignment = 'center',
  minWidth,
  height,
}) => {
  return (
    <WidgetCard
      minWidth={minWidth}
      backgroundColor={backgroundColor}
      shouldHideShadow={shouldHideShadow}
      boxShadowOverride={boxShadowOverride}
      paddingOverride={paddingOverride}
      borderRadius={borderRadiusOverride ?? '24px'}
      alignment={alignment}
      height={height}
    >
      {header && (
        <WidgetHeader
          title={header.title}
          tooltip={header.tooltip}
          action={header.action}
        />
      )}

      {isLoading ? (
        <Div style={{ margin: 'auto 0' }}>
          <LoadingSpinner size="large" />
        </Div>
      ) : isEmpty ? (
        <EmptyWidget
          contentMaxWidth={emptyState.contentMaxWidth}
          icon={emptyState.icon}
          title={emptyState.title}
          description={emptyState.description}
          action={emptyState.action}
        />
      ) : (
        <Flex
          flexDirection="column"
          width="100%"
          style={{ flex: 1, minHeight: 0 }}
        >
          {children}
        </Flex>
      )}
    </WidgetCard>
  )
}
